<template>
    <div id="global-navigation-drawer" @click.self="closeGlobalDrawer">
        <button id="global-navigation-close" type="button" aria-label="Fermer le menu" @click="closeGlobalDrawer">
            <b-icon icon="x" aria-hidden="true" class="primary_color"></b-icon>
        </button>
        <div class="flex-row justify-end mb-2">
            <LanguageSelector></LanguageSelector>
        </div>
        <b-form-input :value="localSearchFilter" :placeholder="$t('recherche_label')"
            @input="onSearchInput"></b-form-input>

        <router-link v-for="link in navigationLinks" :key="link.name" :to="{ path: link.path }"
            @click.native="onLinkClick">
            <b-button class="with_icon" :class="{ 'active': $route.name === link.name }"><b-icon :icon="link.icon"
                    aria-hidden="true"></b-icon>
                {{ link.text }}</b-button>
        </router-link>

    </div>
</template>

<script>
import LanguageSelector from "@/components/LanguageSelector.vue";
import { mapState, mapActions } from "vuex";
const SEARCH_DEBOUNCE_MS = 300;

export default {
    components: { LanguageSelector },
    data() {
        return {
            localSearchFilter: "",
            searchDebounceTimer: null,
        };
    },
    computed: {
        ...mapState("ui", ["globalSearchFilter"]),
        navigationLinks() {
            return this.$store.getters['ui/navigationLinks'];
        },
    },
    watch: {
        globalSearchFilter(value) {
            if (value !== this.localSearchFilter) {
                this.localSearchFilter = value;
            }
        },
    },
    created() {
        this.localSearchFilter = this.globalSearchFilter;
    },
    beforeDestroy() {
        clearTimeout(this.searchDebounceTimer);
    },
    methods: {
        closeGlobalDrawer() {
            this.$store.dispatch("ui/closeGlobalDrawer");
        },
        onLinkClick(link) {
            this.$store.dispatch("ui/closeGlobalDrawer");
        },
        ...mapActions("ui", ["openGlobalDrawer", "updateGlobalSearchFilter"]),
        onSearchInput(nextValue) {
            this.localSearchFilter = nextValue;
            clearTimeout(this.searchDebounceTimer);
            this.searchDebounceTimer = setTimeout(() => {
                this.updateGlobalSearchFilter(nextValue);
            }, SEARCH_DEBOUNCE_MS);
        },
    },
}
</script>

<style lang="scss" scoped></style>